import * as React from 'react';
// mui
import { Card, CardHeader } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';
// redux
import { useSelector } from 'react-redux';
import { selectAllTasks } from '../../store/selectors/taskSelectors';
// types
import Task from '../../interfaces/Task.interface';
import Event from '../../interfaces/Event.interface';
import { selectAllEvents } from '../../store/selectors/eventSelectors';
import RecurringTask from '../../interfaces/RecurringTask.interface';
import { selectAllRecurringTasks } from '../../store/selectors/recuringTaskSelectors';

export default function PriorityChart() {
  const localTasks: Task[] = useSelector(selectAllTasks());
  const localEvents: Event[] = useSelector(selectAllEvents());
  const localRecurringTasks: RecurringTask[] = useSelector(selectAllRecurringTasks());

  const [ chartData, setChartData ] = React.useState<number[]>([]);

  React.useEffect(() => {
    const tempData = [0,0,0,0,0];

    for (let i = 0; i < localTasks.length; i += 1) {
      tempData[localTasks[i].priority - 1] += 1;
    }

    for (let i = 0; i < localEvents.length; i += 1) {
      tempData[localEvents[i].priority - 1] += 1;
    }

    for (let i = 0; i < localRecurringTasks.length; i += 1) {
      tempData[localRecurringTasks[i].priority - 1] += 1;
    }

    setChartData(tempData);
  }, [])

  return (
    <Card sx={{ p: 1 }} variant="outlined">
      <CardHeader
        subheader={"Distribution of Priorities"}
      />
      <BarChart
        series={[
          { data: chartData },
        ]}
        height={290}
        colors={['#556cd6']}
        xAxis={[{ data: ['Optional', 'Low', 'Medium', 'High', 'Critical'], scaleType: 'band' }]}
        margin={{ top: 10, bottom: 30, left: 40, right: 10 }}
      />
    </Card>
  );
}